// extracted by mini-css-extract-plugin
export var legendIndicator = "_f0-1";
export var legendRight = "_f0-0";